import React, {PropTypes as T} from 'react';
import GAPriceType from '../gapricetype';
import get from 'lodash/get';

export default class GAPriceCategory extends React.Component {
  static propTypes = {
    basket: T.object,
    priceCategory: T.object,
    priceCategoryAvailability: T.object,
    prices: T.array,
    totalQuantityInSelection: T.number,
    totalQuantityInSection: T.number,
    sectionId: T.string
  };

  quantityInSelection = (priceCategoryId, priceTypeId) => {
    return get(this.props.basket.sectionBasket, [priceCategoryId, priceTypeId, 'qty']) || 0;
  };

  render () {
    const {
      priceCategory,
      prices,
      basket,
      totalQuantityInSelection,
      totalQuantityInSection,
      priceCategoryAvailability = {}
    } = this.props;

    return (
      <div className="ismmodal__options" data-component="gapicker-pricecategory">
        <h4
          className="ismmodal__title"
          data-component="gapicker-pricecategory-title">
          {priceCategory.code}
        </h4>
        {
          prices.map(
            (price, i) => <GAPriceType
              key={`${priceCategory.number}-${price.priceType}-${i}`}
              price={price}
              categoryId={price.priceCategory}
              categoryAvailability={priceCategoryAvailability[price.priceCategory]}
              priceType={basket.priceTypes[price.priceType]}
              isUnlockingPriceType={basket.isUnlockingPriceType}
              eventId={basket.config.eventId}
              totalQuantityInSelection={totalQuantityInSelection}
              totalQuantityInSection={totalQuantityInSection}
              quantityInSelection={this.quantityInSelection(priceCategory.number, price.priceType)}
              ticketsInBasket={basket.count}
              ticketLimit={basket.config.ticketLimit}
              mandatoryUpsells={basket.mandatoryUpsells}
              moneyFormat={basket.moneyFormat}
              currency={basket.currency}
              prices={this.props.prices}
              feeRollup={basket.feeRollup} />
          )
        }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./frontend/react/components/edp/generaladmission/gapricecategory/index.js